const getChildren = (data, item) => {
    const foundChildren = data.filter(x => x?.treeParent?.id === item?.id);
    if (foundChildren) {
        return {
            ...item,
            childMenu: foundChildren.map(x => getChildren(data, x)).sort((a, b) => a.position - b.position),
        };
    }
    return item;
};
const hierarchicalMenu = (data = []) => {
    const tree = data.map(item => getChildren(data, item)).filter(x => !x.treeParent?.id).sort((a, b) => a.position - b.position);
    return {
        title: '',
        id: 'ROOT',
        childMenu: tree.sort((a, b) => a.position - b.position),
        position: 0,
    };
};
export default hierarchicalMenu;
const findNested = (item, id) => {
    if (item?.id === id)
        return item;
    let found;
    item.childMenu.forEach((inner) => {
        const res = findNested(inner, id);
        if (res) {
            found = res;
        }
    });
    return found;
};
export const hierarchicalMenuSelectChild = (data, startFrom) => {
    const tree = hierarchicalMenu(data);
    return findNested(tree, startFrom);
};
//# sourceMappingURL=hierarchical-menu.js.map